// extracted by mini-css-extract-plugin
export default {"fieldContainer":"fieldContainer---mziTi","barcodeCol":"barcodeCol---wzfip"};